import { env } from "@/shared/config/env"
import { detectPlatform } from "./detect"

const platform = detectPlatform()
const isNative = platform === "ios" || platform === "android"

function resolveServiceUrl(absoluteUrl: string, devPrefix: string): string {
	if (!isNative && import.meta.env.DEV) return devPrefix
	return absoluteUrl
}

export const backendBaseUrl = resolveServiceUrl(
	env.VITE_PUBLIC_SERVICE_BACKEND_API_URL,
	"/backend-service",
)

export const socialBaseUrl = resolveServiceUrl(
	env.VITE_PUBLIC_SERVICE_SOCIAL_API_URL,
	"/social-service",
)
